import { H5, SH3, Stack, XStack } from '@zet/design-system'
import { TransparentHeaderProps } from '@zet/utils/interface'
import { StatusBar } from 'expo-status-bar'

import { GoBackButton } from '../GoBackButton'

export default function TransparentHeader({
  title,
  headerRightButton,
  isCloseIcon,
  showBackIcon,
  showCloseIcon,
  handleBack,
  iconColor,
  badge,
}: TransparentHeaderProps) {
  return (
    <>
      <XStack className="py-4/2 w-screen items-center justify-between px-3">
        <XStack style={{ flex: 5 }}>
          {isCloseIcon && (
            <GoBackButton
              className="bg-decorative-steelblue-translucent mr-3 h-5 w-5 items-center justify-center rounded-lg"
              color={iconColor}
            />
          )}
          {showBackIcon && (
            <GoBackButton
              className="bg-decorative-steelblue-translucent mr-3 h-5 w-5 items-center justify-center rounded-lg"
              color={iconColor}
            />
          )}
          {showCloseIcon && (
            <GoBackButton
              handleBack={handleBack}
              type="Close"
              className="bg-decorative-steelblue-translucent mr-3 h-5 w-5 items-center justify-center rounded-lg"
              color={iconColor}
            />
          )}
          <H5 style={{ maxWidth: '80%' }} className="text-white">
            {title}
          </H5>
          {Boolean(badge) && badge > 0 && (
            <SH3 className="bg-primary-150 px-4/2 mx-2 rounded-xl py-1 text-white">
              {badge}
            </SH3>
          )}
        </XStack>
        {headerRightButton && (
          <Stack style={{ alignItems: 'flex-end' }}>{headerRightButton}</Stack>
        )}
      </XStack>
      <StatusBar style="light" backgroundColor={'#041B3D'} />
    </>
  )
}
